/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/system/contentEditSystemText.tmpl");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");

    var EditorSystemWrapperView = require("content-views/content-edit/system/EditorSystemWrapperView");
    var SkillTabsView = require("content-views/content-edit/SkillTabsView");
    var InputField = require("ui/input-field/InputField");
    var ValidationUtilities = require("utils/ValidationUtilities");

    var EditSystemTextView = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        EditSystemTextView = Marionette.ItemView.extend({
            template: template,
            className: "edit-system-text",

            ui: {
                templateContainer:     ".edit-system-text-container",
                nameWithTimerWrapper:  ".name-with-timer-wrapper .event-name-container",
                nameNoTimerWrapper:    ".name-no-timer-wrapper .event-name-container",
                skillTabsBarContainer:      ".skill-tabs-container",
                editorViewContainer:   ".editor-view-container"
            },
            uiComponents: {
                tabsView: {
                    type: SkillTabsView,
                    options: {
                        el: "view.ui.skillTabsBarContainer",
                        model: "view._getModel",
                        channel: "view._getChannel",
                        reqres: "view._getReqres"
                    }
                },
                editorView: {
                    type: EditorSystemWrapperView,
                    options: {
                        el: "view.ui.editorViewContainer",
                        model: "view._getModel",
                        channel: "view.channel",
                        reqres: "view._getReqres"
                    }
                }
            },

            initialize: function (options) {
                LEContent.logger.debug("Initializing EditSystemText", "EditSystemTextView:initialize");
                this.channel = options.channel;
                this.reqres = options.reqres;
                this.contentModel = options.model.getContentModel();
                this.bindEvents();

                //or just scrap this and create new layout ...
            },
            bindEvents: function () {
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel,this);

            },
            onBeforeRender: function () {
                LEContent.logger.debug("onBeforeRender EditSystemTextView", "EditSystemTextView:onBeforeRender");
            },
            onRender: function () {
                LEContent.logger.debug("onRender EditSystemTextView", "EditSystemTextView:onRender");
                this._updateViewWithChangedModel();
            },
            updateButtonsState: function (isDeleteButtonEnabled) {
                LEContent.logger.debug("updateButtonsState EditSystemTextView", "EditSystemTextView:updateButtonsState");
                this.uiComponents.editorView.updateButtonsState(isDeleteButtonEnabled);
            },

            _updateViewWithChangedModel: function(){
                this.stopListening(this.contentModel);
                this.contentModel = this.model.getContentModel();

                this.listenTo(this.contentModel,"invalid",this._invalid);
                if(this.contentModel.id) {
                    if (this.model.isOnHoldSystemMessage()) {
                        this.ui.templateContainer.addClass("timer");
                        this.ui.nameWithTimerWrapper.text(this.model.getSystemEventName()) ;
                    } else{
                        this.ui.templateContainer.removeClass("timer");
                        this.ui.nameNoTimerWrapper.text(this.model.getSystemEventName()) ;
                    }
                }
            },

            _getContentEnabledState:function(){
                return this.model.getEnabledState();
            },
            _getContentAllowEnabledState :function(){
                return this.model.isEnabledEditable();
            },
            _getModel: function () {
                return this.model;
            },
            _getChannel: function () {
                return this.channel;
            },
            _getReqres: function () {
                return this.reqres;
            },

           _invalid: function(model, errors) {
                LEContent.logger.info("on Invalid called", "EditSystemTextView:onInvalid");
                ValidationUtilities.setValidationErrors(this,false,this.contentModel);
            },

            onClose: function () {
                LEContent.logger.debug("onClose EditSystemTextView", "EditSystemTextView:onClose");
            }
        });

    });
    return EditSystemTextView;
});
